export default {
  header: {
    title: '智慧储能照明可视化平台',
    adminControl: '后台控制',
    threePhase: '三相电'
  },
  weather: {
    sunny: '晴',
    rainy: '雨',
    snowy: '雪',
    cloudy: '阴'
  },
  common: {
    loading: '加载中...',
    voltage: '电压',
    current: '电流',
    power: '功率',
    consumption: '消耗',
    frequency: '频率',
    grid: '市电',
    storage: '储能',
    pv: '光伏',
    back: '返回',
    on: '开启',
    off: '关闭'
  },
  overview: {
    title: '设备概况',
    online: '在线',
    offline: '离线'
  },
  benefits: {
    title: '环保效益',
    reduction: '减排',
    planting: '植树',
    trees: '棵'
  },
  cumulative: {
    title: '年度累计效益',
    gridConsumption: '市电消耗',
    storageConsumption: '储能消耗',
    pvGeneration: '光伏发电'
  },
  storage: {
    title: '储能参数',
    batteryVoltage: '电池电压',
    batteryCurrent: '电池电流',
    soc: 'soc'
  },
  pv: {
    title: '光伏参数',
    irradiation: '辐照',
    voltage: 'PV电压',
    current: 'PV电流',
    power: '充电功率'
  },
  grid: {
    title: '市电参数',
    voltage: '市电电压',
    current: '市电电流',
    totalPower: '总功率'
  },
  center: {
    title: '用电量统计',
    peakStorage: '峰时储能放电量',
    lowValley: '低谷照明/储存电量',
    pvGeneration: '光伏发电量'
  },
  bms: {
    title: 'BMS电池监测界面',
    deviceId: '设备ID',
    prevPage: '上一页',
    nextPage: '下一页',
    temperature: '温度',
    endurance: '续航时间',
    pvVoltage: 'PV电压',
    totalVoltage: '总电压',
    remainingEnergy: '剩余电量',
    power: '功率',
    equilibriumState: '均衡状态',
    pvDailyGeneration: '光伏日发电量',
    maxVoltage: '单体最高电压',
    minVoltage: '单体最低电压',
    chargingCapacity: '充电电量',
    dischargeCapacity: '放电电量',
    hours: '小时',
    minutes: '分',
    workingCurrent: '工作电流',
    noData: '暂无数据'
  },
  map: {
    title: '储能路灯分布地图界面',
    costSavings: '节省电费',
    batteryCapacity: '电池容量',
    differentialPressure: '压差',
    peakTime: '高峰时间',
    lowValleyTime: '低谷时间',
    lowValleyPrice: '低谷电价',
    peakPrice: '高峰电价',
    confirm: '确定',
    cancel: '取消',
    streetLight: '路灯',
    lowValleyLightingYear: '低谷照明 & 储存电量(年)',
    peakStorageDischargeYear: '峰时储能放电量(年)',
    photovoltaicYear: '光伏充电量(年)',
    carbonReduction: '二氧化碳减排',
    equivalentPlanting: '等效植树'
  },
  electricity: {
    title: '市电电能统计',
    pvTitle: '光伏电能统计',
    municipalElectricity: '市电电能统计',
    photovoltaicEnergy: '光伏电能统计',
    power: '功率',
    powerUnit: '(W)',
    gridVoltage: '市电电压',
    gridVoltageUnit: '(V)',
    gridCurrent: '市电电流',
    gridCurrentUnit: '(mA)',
    powerFactor: '功率因数',
    powerFactorUnit: '(PF)',
    gridConsumption: '市电消耗',
    gridConsumptionUnit: '(Wh)',
    irradiation: '辐照',
    pvVoltage: 'PV电压',
    pvCurrent: 'PV电流',
    chargePower: '充电电量',
    prevPage: '上一页',
    nextPage: '下一页',
    noData: '暂无数据'
  },
  threePhase: {
    title: '智电云眼可视化系统',
    onlineRate: '设备在线率',
    voltageA: 'A线电压',
    voltageB: 'B线电压',
    voltageC: 'C线电压',
    phaseVoltage: '相电压',
    projectName: '项目名称',
    threePhase: '三相',
    combinedPhase: '合相',
    positioning: '定位',
    compare: '同比',
    phaseA: 'A 相',
    phaseB: 'B 相',
    phaseC: 'C 相',
    harmonicDistortion: '谐波失真度',
    current: '电流',
    power: '功率',
    powerFactor: '功率因数',
    powerStats: '用电量统计',
    energyConsumption: '能源消耗',
    months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    consumption: '能耗',
    tbd: '待定',
    button: '按钮'
  }
}
